import { useViewModel } from '../../utils/viewmodels/useViewModel';
import { ConfirmModalViewModel, type ConfirmModalState } from './confirm-modal.viewmodel';

export function useConfirmModal(): [ConfirmModalState, Omit<ConfirmModalViewModel, 'state'>] {
  return useViewModel<ConfirmModalState, ConfirmModalViewModel>(() => new ConfirmModalViewModel());
}
